import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { CircularProgress, Typography } from "@material-ui/core";

import ModalImage from "react-modal-image";
import api from "../../services/api";

const useStyles = makeStyles(theme => ({
	messageMedia: {
		objectFit: "cover",
		width: 250,
		height: "auto", // Redimensionar automaticamente a altura para manter a proporção
		borderTopLeftRadius: 8,
		borderTopRightRadius: 8,
		borderBottomLeftRadius: 8,
		borderBottomRightRadius: 8,
	},
	imageState: {
		width: 250,
		minHeight: 150,
		borderRadius: 8,
		backgroundColor: theme.palette.type === "dark" ? "#111827" : "#f3f4f6",
		color: theme.palette.text.secondary,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		flexDirection: "column",
		gap: 8,
		padding: 16,
		textAlign: "center",
	}
}));

const isValidImageUrl = value => {
	if (!value || ["null", "undefined"].includes(String(value).trim())) return false;

	try {
		new URL(value, window.location.origin);
		return true;
	} catch {
		return false;
	}
};

const ModalImageCors = ({ imageUrl }) => {
	const classes = useStyles();
	const [fetching, setFetching] = useState(true);
	const [blobUrl, setBlobUrl] = useState("");
	const [failed, setFailed] = useState(false);

	useEffect(() => {
		let objectUrl = "";

		if (!isValidImageUrl(imageUrl)) {
			setFetching(false);
			setBlobUrl("");
			setFailed(true);
			return undefined;
		}

		setFetching(true);
		setBlobUrl("");
		setFailed(false);

		const fetchImage = async () => {
			try {
				const { data, headers } = await api.get(imageUrl, {
					responseType: "blob",
				});
				objectUrl = window.URL.createObjectURL(
					new Blob([data], { type: headers["content-type"] })
				);
				setBlobUrl(objectUrl);
			} catch {
				setBlobUrl("");
				setFailed(true);
			} finally {
				setFetching(false);
			}
		};
		fetchImage();

		return () => {
			if (objectUrl) {
				window.URL.revokeObjectURL(objectUrl);
			}
		};
	}, [imageUrl]);

	if (!isValidImageUrl(imageUrl) || failed) {
		return (
			<div className={classes.imageState}>
				<Typography variant="body2">Imagem não disponível</Typography>
			</div>
		);
	}

	if (fetching && !blobUrl) {
		return (
			<div className={classes.imageState}>
				<CircularProgress size={24} />
				<Typography variant="caption">Carregando imagem...</Typography>
			</div>
		);
	}

	return (
		<ModalImage
			className={classes.messageMedia}
			smallSrcSet={!fetching && blobUrl ? blobUrl : imageUrl}
			medium={!fetching && blobUrl ? blobUrl : imageUrl}
			large={!fetching && blobUrl ? blobUrl : imageUrl}
			alt="image"
			showRotate={true}
		/>
	);
};

export default ModalImageCors;
